import { noDataImg } from "assets/images";
import React from "react";
import "./Placeholder.scss";
const Placeholder = ({ image, title, description }) => {
  return (
    <div className="placeholder_wrap">
      <img src={image || noDataImg} alt="" />
      {title && <h5>{title}</h5>}
      {description && <p>{description}</p>}
    </div>
  );
};

export default Placeholder;
